import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { categories } from "@/mocks/categories";
import { articlePreviews } from "@/mocks/articlePreviews";

const categoryImages: Record<string, string> = {
  Shoes: "https://readdy.ai/api/search-image?query=Elegant%20fashion%20sneakers%20on%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20clean%20minimalist%20aesthetic%2C%20editorial%20product%20photography%2C%20beige%20and%20sand%20tones%2C%20subtle%20shadows%2C%20European%20style%2C%20high%20detail%2C%20simple%20elegant%20composition&width=400&height=400&seq=cat-img-shoes&orientation=squarish",
  "Hoodies/Sweaters": "https://readdy.ai/api/search-image?query=Stylish%20cozy%20hoodie%20sweater%20on%20warm%20beige%20surface%2C%20natural%20soft%20daylight%2C%20clean%20minimalist%20aesthetic%2C%20editorial%20product%20photography%2C%20cream%20tones%2C%20subtle%20shadows%2C%20European%20style%2C%20high%20detail%2C%20elegant%20simple%20composition&width=400&height=400&seq=cat-img-hoodies&orientation=squarish",
  "T-Shirts": "https://readdy.ai/api/search-image?query=Modern%20minimal%20t-shirt%20on%20warm%20cream%20surface%2C%20soft%20natural%20light%2C%20clean%20aesthetic%2C%20editorial%20product%20photography%2C%20neutral%20warm%20tones%2C%20subtle%20shadows%2C%20European%20style%2C%20high%20detail%2C%20elegant%20composition&width=400&height=400&seq=cat-img-tshirts&orientation=squarish",
  Jackets: "https://readdy.ai/api/search-image?query=Stylish%20modern%20jacket%20on%20warm%20beige%20surface%2C%20natural%20soft%20daylight%2C%20clean%20minimalist%20aesthetic%2C%20editorial%20product%20photography%2C%20cream%20and%20sand%20tones%2C%20subtle%20shadows%2C%20European%20style%2C%20high%20detail&width=400&height=400&seq=cat-img-jackets&orientation=squarish",
  "Pants/Shorts": "https://readdy.ai/api/search-image?query=Elegant%20casual%20pants%20on%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20clean%20minimalist%20aesthetic%2C%20editorial%20product%20photography%2C%20neutral%20warm%20tones%2C%20subtle%20shadows%2C%20European%20style%2C%20high%20detail&width=400&height=400&seq=cat-img-pants&orientation=squarish",
  Headwear: "https://readdy.ai/api/search-image?query=Stylish%20modern%20cap%20hat%20on%20warm%20beige%20surface%2C%20natural%20soft%20daylight%2C%20clean%20minimalist%20aesthetic%2C%20editorial%20product%20photography%2C%20cream%20tones%2C%20subtle%20shadows%2C%20European%20style%2C%20high%20detail%2C%20elegant%20composition&width=400&height=400&seq=cat-img-headwear&orientation=squarish",
  Sets: "https://readdy.ai/api/search-image?query=Coordinated%20fashion%20clothing%20set%20on%20warm%20cream%20surface%2C%20soft%20natural%20light%2C%20clean%20aesthetic%2C%20editorial%20product%20photography%2C%20neutral%20warm%20tones%2C%20subtle%20shadows%2C%20European%20style%2C%20high%20detail%2C%20elegant%20composition&width=400&height=400&seq=cat-img-sets&orientation=squarish",
  "Underwear/Underpants": "https://readdy.ai/api/search-image?query=Soft%20cotton%20undergarments%20on%20warm%20beige%20surface%2C%20natural%20soft%20daylight%2C%20clean%20minimalist%20aesthetic%2C%20editorial%20product%20photography%2C%20cream%20tones%2C%20subtle%20shadows%2C%20European%20style%2C%20elegant%20simple%20composition&width=400&height=400&seq=cat-img-underwear&orientation=squarish",
  Jersey: "https://readdy.ai/api/search-image?query=Modern%20sports%20jersey%20on%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20clean%20minimalist%20aesthetic%2C%20editorial%20product%20photography%2C%20neutral%20warm%20tones%2C%20subtle%20shadows%2C%20European%20style%2C%20high%20detail&width=400&height=400&seq=cat-img-jersey&orientation=squarish",
  Accessories: "https://readdy.ai/api/search-image?query=Elegant%20fashion%20accessories%20sunglasses%20and%20watch%20on%20warm%20beige%20surface%2C%20natural%20soft%20daylight%2C%20clean%20minimalist%20aesthetic%2C%20editorial%20product%20photography%2C%20cream%20tones%2C%20subtle%20shadows%2C%20European%20style%2C%20high%20detail&width=400&height=400&seq=cat-img-accessories&orientation=squarish",
  Bags: "https://readdy.ai/api/search-image?query=Stylish%20modern%20handbag%20on%20warm%20cream%20surface%2C%20soft%20natural%20light%2C%20clean%20aesthetic%2C%20editorial%20product%20photography%2C%20neutral%20warm%20tones%2C%20subtle%20shadows%2C%20European%20style%2C%20high%20detail%2C%20elegant%20composition&width=400&height=400&seq=cat-img-bags&orientation=squarish",
  Belts: "https://readdy.ai/api/search-image?query=Elegant%20leather%20belt%20on%20warm%20beige%20surface%2C%20natural%20soft%20daylight%2C%20clean%20minimalist%20aesthetic%2C%20editorial%20product%20photography%2C%20cream%20and%20sand%20tones%2C%20subtle%20shadows%2C%20European%20style%2C%20high%20detail&width=400&height=400&seq=cat-img-belts&orientation=squarish",
  Perfumes: "https://readdy.ai/api/search-image?query=Luxury%20perfume%20bottle%20on%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20clean%20minimalist%20aesthetic%2C%20editorial%20product%20photography%2C%20neutral%20warm%20tones%2C%20subtle%20shadows%2C%20European%20style%2C%20high%20detail%2C%20elegant%20composition&width=400&height=400&seq=cat-img-perfumes&orientation=squarish",
  "Other Stuff": "https://readdy.ai/api/search-image?query=Miscellaneous%20stylish%20lifestyle%20products%20on%20warm%20beige%20surface%2C%20natural%20soft%20daylight%2C%20clean%20minimalist%20aesthetic%2C%20editorial%20product%20photography%2C%20cream%20tones%2C%20subtle%20shadows%2C%20European%20style%2C%20high%20detail&width=400&height=400&seq=cat-img-other&orientation=squarish",
};

function CategoryCard({ cat }: { cat: (typeof categories)[0] }) {
  const imgSrc = categoryImages[cat.name] || categoryImages["Other Stuff"];
  return (
    <a
      href={cat.url}
      target="_blank"
      rel="noopener nofollow"
      className="group relative flex flex-col bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer hover:-translate-y-1 overflow-hidden"
    >
      <div className="w-full aspect-square overflow-hidden">
        <img
          src={imgSrc}
          alt={cat.label}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-[400ms]"
          loading="lazy"
        />
      </div>
      <div className="flex flex-col items-center gap-1.5 p-3 md:p-4">
        <span className="text-foreground-800 font-medium text-xs md:text-sm text-center leading-tight">
          {cat.label}
        </span>
        <span className="text-foreground-400 text-[10px] md:text-xs opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap">
          Zobacz produkty →
        </span>
      </div>
    </a>
  );
}

export default function Home() {
  const { t } = useTranslation();
  const [selectedCategory, setSelectedCategory] = useState("");

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Kakobuy Polska",
    "url": "https://kakobuypolska.boats",
    "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png",
    "description": "Kakobuy Spreadsheet Polska – kompletne listy produktów i przewodniki zakupowe dla polskich kupujących",
    "inLanguage": "pl",
    "sameAs": [
      "https://kaspreadsheet.com"
    ]
  };

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Kakobuy Spreadsheet Polska – Najlepsze Znaleziska Produktów",
    "description": "Znajdź popularne produkty z Chin szybciej dzięki aktualnym listom Kakobuy Spreadsheet. Sprawdzaj kategorie, porównania, przewodniki zakupowe i bezpieczne metody zamawiania.",
    "url": "https://kakobuypolska.boats/",
    "inLanguage": "pl",
    "isPartOf": {
      "@type": "WebSite",
      "name": "Kakobuy Polska",
      "url": "https://kakobuypolska.boats"
    }
  };

  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      setSelectedCategory("");
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20lifestyle%20product%20photography%20with%20elegant%20sneakers%20hoodies%20fashion%20accessories%20and%20bags%20on%20clean%20light%20wooden%20surface%2C%20soft%20natural%20daylight%2C%20cream%20and%20beige%20tones%2C%20editorial%20aesthetic%2C%20sophisticated%20composition%2C%20subtle%20soft%20shadows%2C%20high%20end%20product%20display%2C%20neutral%20warm%20palette%2C%20European%20style&width=1600&height=900&seq=kakobuy-hero-v2&orientation=landscape"
              alt="Kakobuy Spreadsheet Polska - produkty"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/35"></div>
          </div>

          <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-16">
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 leading-tight">
              {t("hero.title")}
            </h1>
            <p className="text-white/85 text-sm md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
              {t("hero.subtitle")}
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 mb-10">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 dark:text-foreground-950 font-heading font-semibold text-base md:text-lg rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
              >
                {t("button.kakobuy")}
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-white/15 backdrop-blur-sm border border-white/30 text-white font-heading font-semibold text-base md:text-lg rounded-full hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                {t("button.buynow")}
                <i className="ri-shopping-bag-line"></i>
              </a>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
              {[
                { icon: "ri-checkbox-circle-line", text: t("hero.trust.1") },
                { icon: "ri-guide-line", text: t("hero.trust.2") },
                { icon: "ri-scales-3-line", text: t("hero.trust.3") },
                { icon: "ri-shield-check-line", text: t("hero.trust.4") },
              ].map((item, i) => (
                <div
                  key={i}
                  className="flex items-center gap-1.5 text-white/80 text-xs md:text-sm"
                >
                  <i className={`${item.icon} text-primary-400 text-sm`}></i>
                  <span className="whitespace-nowrap">{item.text}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Category Dropdown + Quick Links Section with Images */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                {t("section.categories.title")}
              </h2>
              <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
                {t("section.categories.subtitle")}
              </p>
            </div>

            <div className="max-w-md mx-auto mb-10">
              <div className="relative">
                <select
                  value={selectedCategory}
                  onChange={handleDropdownChange}
                  className="w-full appearance-none px-5 py-3.5 bg-background-50 border-2 border-background-200/70 rounded-xl text-foreground-700 text-sm font-medium focus:outline-none focus:border-primary-400 transition-colors cursor-pointer pr-12"
                >
                  <option value="" disabled>
                    {t("section.categories.dropdown")}
                  </option>
                  {categories.map((cat) => (
                    <option key={cat.name} value={cat.url}>
                      {cat.label}
                    </option>
                  ))}
                </select>
                <div className="absolute right-4 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center pointer-events-none">
                  <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
              {categories.map((cat) => (
                <CategoryCard key={cat.name} cat={cat} />
              ))}
            </div>
          </div>
        </section>

        {/* Problem / Solution Section */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full max-w-5xl mx-auto px-4 md:px-6">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-10">
              {t("section.problem.title")}
            </h2>

            <div className="overflow-x-auto">
              <table className="w-full border-collapse">
                <thead>
                  <tr className="border-b-2 border-background-200/70">
                    <th className="text-left py-4 px-4 font-heading font-semibold text-foreground-800 text-sm md:text-base"></th>
                    <th className="text-center py-4 px-4 font-heading font-semibold text-foreground-700 text-sm md:text-base">
                      <span className="inline-flex items-center gap-2">
                        <i className="ri-close-circle-line text-accent-500"></i>
                        {t("section.problem.col1")}
                      </span>
                    </th>
                    <th className="text-center py-4 px-4 font-heading font-semibold text-primary-600 text-sm md:text-base">
                      <span className="inline-flex items-center gap-2">
                        <i className="ri-checkbox-circle-line text-primary-500"></i>
                        {t("section.problem.col2")}
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    {
                      title: t("section.problem.row1.title"),
                      trad: t("section.problem.row1.traditional"),
                      kak: t("section.problem.row1.kakobuy"),
                    },
                    {
                      title: t("section.problem.row2.title"),
                      trad: t("section.problem.row2.traditional"),
                      kak: t("section.problem.row2.kakobuy"),
                    },
                    {
                      title: t("section.problem.row3.title"),
                      trad: t("section.problem.row3.traditional"),
                      kak: t("section.problem.row3.kakobuy"),
                    },
                    {
                      title: t("section.problem.row4.title"),
                      trad: t("section.problem.row4.traditional"),
                      kak: t("section.problem.row4.kakobuy"),
                    },
                  ].map((row, i) => (
                    <tr
                      key={i}
                      className="border-b border-background-200/70 hover:bg-background-50/50 transition-colors"
                    >
                      <td className="py-3.5 px-4 font-medium text-foreground-800 text-sm md:text-base">
                        {row.title}
                      </td>
                      <td className="py-3.5 px-4 text-center text-foreground-500 text-sm md:text-base">
                        {row.trad}
                      </td>
                      <td className="py-3.5 px-4 text-center text-primary-600 font-semibold text-sm md:text-base">
                        {row.kak}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* How It Works */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full max-w-5xl mx-auto px-4 md:px-6">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-10">
              {t("section.how.title")}
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
              {[
                {
                  step: "01",
                  title: t("section.how.step1"),
                  desc: "Wybierz interesującą Cię kategorię z rozwijanej listy lub kliknij kartę kategorii poniżej. Każda kategoria zawiera starannie wyselekcjonowane produkty z Kakobuy Spreadsheet.",
                  icon: "ri-check-double-line",
                  img: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20category%20selection%20interface%20on%20warm%20cream%20desk%20with%20fashion%20items%2C%20soft%20natural%20light%2C%20clean%20aesthetic%2C%20editorial%20product%20photography%2C%20neutral%20warm%20tones%2C%20European%20style%2C%20high%20detail&width=600&height=400&seq=how-step1&orientation=landscape",
                },
                {
                  step: "02",
                  title: t("section.how.step2"),
                  desc: "Przejrzyj dostępne produkty, sprawdź zdjęcia QC, porównaj ceny i przeczytaj opisy. Nasze listy są regularnie aktualizowane, aby zapewnić najświeższe znaleziska.",
                  icon: "ri-search-eye-line",
                  img: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20product%20inspection%20with%20magnifying%20glass%20over%20clothing%20on%20warm%20beige%20surface%2C%20natural%20soft%20daylight%2C%20clean%20aesthetic%2C%20editorial%20photography%2C%20cream%20tones%2C%20subtle%20shadows%2C%20European%20style&width=600&height=400&seq=how-step2&orientation=landscape",
                },
                {
                  step: "03",
                  title: t("section.how.step3"),
                  desc: "Kliknij przycisk, aby przejść do głównej platformy Kakobuy Spreadsheet, gdzie możesz dokonać zakupu i skorzystać z pełnej funkcjonalności arkusza.",
                  icon: "ri-external-link-line",
                  img: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20shopping%20completion%20concept%20with%20smartphone%20displaying%20success%20on%20warm%20cream%20desk%2C%20natural%20light%2C%20clean%20aesthetic%2C%20editorial%20photography%2C%20neutral%20warm%20tones%2C%20European%20style%2C%20high%20detail&width=600&height=400&seq=how-step3&orientation=landscape",
                },
              ].map((item, i) => (
                <div
                  key={i}
                  className="relative flex flex-col bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden"
                >
                  <div className="w-full h-36 md:h-40 overflow-hidden">
                    <img src={item.img} alt={item.title} className="w-full h-full object-cover object-top" loading="lazy" />
                  </div>
                  <div className="absolute top-3 left-3 w-8 h-8 flex items-center justify-center bg-accent-500 text-background-50 dark:text-foreground-950 font-heading font-bold text-sm rounded-full">
                    {item.step}
                  </div>
                  <div className="p-5 md:p-6 text-center flex flex-col items-center">
                    <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-xl mb-3">
                      <i className={`${item.icon} text-xl text-primary-600`}></i>
                    </div>
                    <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-2">
                      {item.title}
                    </h3>
                    <p className="text-foreground-600 text-xs md:text-sm leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Image Banner Section */}
        <section className="relative w-full h-[300px] md:h-[400px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20flatlay%20with%20sneakers%20watches%20bags%20sunglasses%20and%20accessories%20arranged%20on%20warm%20beige%20textured%20surface%2C%20soft%20natural%20daylight%2C%20clean%20aesthetic%2C%20editorial%20product%20photography%2C%20cream%20and%20sand%20tones%2C%20sophisticated%20composition%2C%20high%20detail%2C%20European%20style&width=1600&height=800&seq=kakobuy-mid-banner-v2&orientation=landscape"
            alt="Kakobuy Spreadsheet - moda i akcesoria"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/15 to-black/20"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center px-4">
              <p className="text-white/90 font-heading text-xl md:text-3xl font-bold mb-4">
                Odkryj setki sprawdzonych produktów
              </p>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-8 py-3 bg-white text-foreground-900 font-heading font-semibold text-sm md:text-base rounded-full hover:bg-background-50 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Zobacz Kakobuy Spreadsheet
                <i className="ri-arrow-right-up-line"></i>
              </a>
            </div>
          </div>
        </section>

        {/* SEO Articles Grid - 9 Articles */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                Poradniki i artykuły Kakobuy Spreadsheet
              </h2>
              <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
                Poznaj wszystkie aspekty zakupów przez Kakobuy — od bezpieczeństwa po trendy modowe
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {articlePreviews.map((article, i) => (
                <Link
                  key={i}
                  to={`/artykul/${article.slug}`}
                  className="group flex flex-col bg-background-100 rounded-xl border border-background-200/70 hover:border-primary-300 transition-all duration-300 hover:-translate-y-1 overflow-hidden cursor-pointer"
                >
                  <div className="w-full h-44 md:h-48 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-[400ms]"
                      loading="lazy"
                    />
                  </div>
                  <div className="flex flex-col flex-1 p-4 md:p-5">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="inline-flex items-center gap-1 px-2.5 py-0.5 bg-secondary-100 text-secondary-700 text-[10px] md:text-xs font-semibold rounded-full whitespace-nowrap">
                        <i className={`${article.tagIcon} text-[10px]`}></i>
                        {article.tag}
                      </span>
                      <span className="text-foreground-400 text-[10px] md:text-xs whitespace-nowrap">{article.date}</span>
                    </div>
                    <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base leading-snug mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-foreground-500 text-xs md:text-sm leading-relaxed line-clamp-2 mb-3 flex-1">
                      {article.excerpt}
                    </p>
                    <span className="inline-flex items-center gap-1 text-primary-500 font-semibold text-xs md:text-sm whitespace-nowrap">
                      Czytaj więcej
                      <i className="ri-arrow-right-line text-xs group-hover:translate-x-1 transition-transform"></i>
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Original Article Preview (Featured) */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
            <article className="bg-background-50 rounded-2xl p-6 md:p-10 border border-background-200/70">
              <div className="flex flex-col md:flex-row gap-6 mb-6">
                <div className="w-full md:w-48 h-36 md:h-auto rounded-xl overflow-hidden flex-shrink-0">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20workspace%20with%20laptop%20displaying%20spreadsheet%20next%20to%20fashion%20accessories%20on%20warm%20cream%20desk%2C%20soft%20natural%20light%2C%20clean%20aesthetic%2C%20editorial%20productivity%20photography%2C%20neutral%20warm%20tones%2C%20European%20style%2C%20high%20detail&width=400&height=400&seq=featured-article-img&orientation=squarish"
                    alt="Poradnik Kakobuy Spreadsheet"
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-3">
                    {t("section.article.title")}
                  </h2>
                  <p className="text-sm md:text-base leading-relaxed text-foreground-600">
                    {t("section.article.excerpt")}
                  </p>
                </div>
              </div>
              <p className="text-sm md:text-base leading-relaxed text-foreground-600 mb-6">
                W dzisiejszych czasach coraz więcej Polaków odkrywa zalety zakupów na chińskich platformach e-commerce. Dzięki agentom takim jak Kakobuy, proces zamawiania produktów z Taobao, Weidian czy 1688 stał się prostszy niż kiedykolwiek wcześniej. Kakobuy Spreadsheet to narzędzie, które pozwala zaoszczędzić godziny przeszukiwania ofert — zamiast tego otrzymujesz gotowe, posegregowane listy najlepszych produktów w różnych kategoriach.
              </p>
              <p className="text-sm md:text-base leading-relaxed text-foreground-600 mb-8">
                Niezależnie od tego, czy szukasz najnowszych sneakersów, modnych bluz, eleganckich torebek czy praktycznych akcesoriów — Kakobuy Spreadsheet ma wszystko, czego potrzebujesz. Każdy produkt w arkuszu został sprawdzony pod kątem jakości, a zdjęcia QC pomagają uniknąć rozczarowań przy odbiorze paczki.
              </p>

              <div className="flex flex-wrap gap-3">
                <Link
                  to="/artykul/kakobuy-spreadsheet-poradnik"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 font-heading font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
                >
                  {t("section.article.readmore")}
                  <i className="ri-arrow-right-line"></i>
                </Link>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-secondary-100 text-secondary-800 font-heading font-semibold text-sm rounded-full hover:bg-secondary-200 transition-all duration-300 whitespace-nowrap"
                >
                  Kakobuy Spreadsheet
                  <i className="ri-external-link-line"></i>
                </a>
              </div>
            </article>
          </div>
        </section>

        {/* Final CTA */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full max-w-3xl mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
              Gotowy, aby zacząć?
            </h2>
            <p className="text-foreground-600 text-sm md:text-base mb-8 max-w-xl mx-auto">
              Przejdź do Kakobuy Spreadsheet i odkryj tysiące sprawdzonych produktów. Oszczędzaj czas i pieniądze dzięki gotowym listom zakupowym.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 dark:text-foreground-950 font-heading font-semibold text-base rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
              >
                {t("button.kakobuy")}
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-background-50 border-2 border-foreground-200 text-foreground-800 font-heading font-semibold text-base rounded-full hover:border-primary-400 hover:text-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                {t("button.buynow")}
                <i className="ri-shopping-bag-line"></i>
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      {/* Schema.org Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
    </div>
  );
}